<template>
  <CustomPicker
    v-if="countryList && countryList.length"
    :isInDialog="isInDialog"
    :isLoading="isLoading"
    :closeOnSelect="true"
    title="name"
    :inputLabel="inputLabel"
    :items="countryList"
    :filter="handleSearch"
    v-model="countryModelValue"
  >
    <template #labelOption="data">
      <span style="margin-left: 3px">
        {{ data.item.name }}
      </span>
      <bdi> ({{ data.item.countryCode }}) </bdi>
    </template>
    <template #selectedOption="data">
      <span style="margin-left: 3px">
        {{ data.item.name }}
      </span>
      <bdi> ({{ data.item.countryCode }}) </bdi>
    </template>
  </CustomPicker>
</template>

<script>
export default {
  emits: ["input", "getCountryCode", "getDefaultCountry"],
  props: {
    value: {
      type: [Object, null],
      default: null,
    },
    defaultIsoCode: {
      type: String,
      required: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: String,
      default: "کد کشور",
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    this.getCountryCodes();
  },
  data() {
    return {
      isLoading: false,
      countryList: null,
    };
  },
  methods: {
    async getCountryCodes() {
      try {
        this.isLoading = true;
        const _this = this;
        const getCountryCodes = new GetCountryCodes(_this);
        await getCountryCodes.fetch((response) => {
          _this.countryList = response.data;
          if (_this.defaultIsoCode) {
            const findedCountry = _this.countryList.find(
              (item) => item.isoCode == _this.defaultIsoCode
            );
            if (findedCountry) {
              _this.$emit("getDefaultCountry", findedCountry);
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleSearch(options, search) {
      const formattedSearch = search.replace(/^0+/, "+").toLowerCase();

      // Filter the array of options based on the search term
      return options.filter(
        (option) =>
          option.name.toLowerCase().includes(search.toLowerCase()) ||
          option.countryCode.includes(formattedSearch)
      );
    },
  },
  computed: {
    countryModelValue: {
      set(value) {
        this.$emit("input", value);
        this.$emit("getCountryCode", value);
      },
      get() {
        return this.value;
      },
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
import { GetCountryCodes } from "@/libs/Api/Account";
</script>
